module.exports = __webpack_public_path__ + "static/img/mobile-web-img03@t.148f36e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-tms/mobile-web-img03@t.png
// module id = K1VL
// module chunks = 0